 import ApiCConverter  from "../Components/ApiCConverter.jsx";
 import BudgetCalculator from "../Components/BudgetCalculator.jsx";


 export default function Budget(){
    return (
      <div>
        <BudgetCalculator />
        <ApiCConverter />
      </div>
    );
 }